import React, { Component, createRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import NavigationBar from './Component/Include/Navbar/Navbar';
import AppContext from './Context/AppContext';
import Footer from './Component/Include/Footer/Footer';

// import Cursor from './Component/Utilities/Cursor/Cursor';
// import CursorContext from './Context/CursorContext';

import Routes from './Routing/Routing';
// import Init from './Init/Init';
import WhatsappButton from './Component/Utilities/WhatsappButton/WhatsappButton';
// import SNI from './Component/Utilities/MetaTag/MetaTag';

/* Analytics */
// import MetaPixel from './Component/Utilities/MetaPixel/MetaPixel';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import CustomToast from './Component/Utilities/Toast/Toast';

if (process.env.REACT_APP_ENV === 'production') {
  /* GA */
  // const TRACKING_ID = "UA-250517852-1"; // OUR_TRACKING_ID
  // ReactGA.initialize(TRACKING_ID);

  /* Tag Manager */
  const tagManagerConfig = {
    gtmId: 'GTM-KWGHCF4J',
    // dataLayerName: 'PageDataLayer'
  }
  TagManager.initialize(tagManagerConfig);

  /* GA 4 */
  const MEASUREMENT_ID = 'G-9MQCMWK6Q1';
  ReactGA.initialize(MEASUREMENT_ID);
}

class App extends Component {
  constructor(props) {
    super(props);

    const currentDt = new Date();
    const announcementDtEnd = new Date('2026-03-24T00:00:00');

    this.state = {
      currentRoute: window.location.pathname,
      appRef: createRef(),
      showAnnouncement: currentDt < announcementDtEnd
    }
  };

  static contextType = AppContext;

  componentDidMount() {
    // let { pathname, search, hash } = window.location;

    // ReactGA.send({
    //   hitType: 'pageview',
    //   path: pathname + hash + search,
    //   title: pathname
    // });
  }

  hideNav(currentPath) {
    let routes = Routes();

    let hasNavRoutes = routes.filter((value, key) => {
      return !value.showNav;
    }).map((item) => {
      return item.path;
    });

    return hasNavRoutes.includes(currentPath);
  }

  hideFooter(currentPath) {
    let routes = Routes();

    let hasNavRoutes = routes.filter((value, key) => {
      return !value.showFooter;
    }).map((item) => {
      return item.path;
    });

    return hasNavRoutes.includes(currentPath);
  }

  render() {
    const routes = Routes();
    const state = this.state;

    // let hasFooterRoutes = routes.filter( (value, key) => {
    //   return value.showFooter;
    // } ).map( (item) => {
    //   return item.path;
    // } );

    const handleNavClick = (path) => {
      let state = this.state;
      state.currentRoute = path;

      this.setState(state);
    }

    return (
      <AppContext.Provider value={{
        refresh: () => this.forceUpdate()
      }}>
        <div ref={state.appRef} className={"App"}>
          {/* <SNI /> */}
          {/* <MetaPixel /> */}
          <CustomToast
            image=""
            title="Informasi Penting!"
            text={``}
            status={2} // 0: Failed; 1: Success
            show={state.showAnnouncement}
            position='top-start'
            onClose={() => {
              let state = this.state;
              state.showAnnouncement = false;

              this.setState(state);
            }}
          >
            <p>
              Dear Customer Yoboy Cup,
            </p>

            <p>
              Kami informasikan dari tanggal 19-23 Maret off pengiriman dikarenakan libur lebaran. Semua pesanan terakhir masuk di tanggal 18 Maret & pengiriman kembali dimulai tanggal 24 Maret 2026 (sesuai jadwal buka ekspedisi).
            </p>

            <p>
              Terima Kasih & Selamat Lebaran.
            </p>
          </CustomToast>
          <WhatsappButton isFixed={true} />
          <NavigationBar hide={this.hideNav(state.currentRoute)} navList={routes} onChoose={(path) => handleNavClick(path)} />
          <Footer hide={this.hideFooter(state.currentRoute)} />
        </div>
      </AppContext.Provider>
    );
  }
}

export default App;
